module.exports = __webpack_public_path__ + "static/1-9552b54746b3ab44ea0002d25697e1fa.jpg";